import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserPreferencesFacade } from '@app/core/stores/user-preferences';

@Component({
  selector: 'topo-right-drawer',
  templateUrl: './right-drawer.component.html',
  styleUrls: ['./right-drawer.component.scss'],
  standalone: false
})
export class RightDrawerComponent {
  @Input() isOpen = false;
  @Input() isMap = false;
  @Input() isWallDisplay = false;
  @Input() zIndex = 10;

  @Output() visibilityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(protected userPref: UserPreferencesFacade) {}

  openCloseClick(): void {
    this.visibilityChanged.emit(!this.isOpen);
  }
}
